import { forwardRef, type SVGProps } from 'react';

export interface ExtendBackgroundIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const ExtendBackgroundIcon = forwardRef<SVGSVGElement, ExtendBackgroundIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 12 12">
    <g clip-path="url(#a)" fill="currentColor">
      <path d="M3.5 11.5V9C3.5 8.72386 3.27614 8.5 3 8.5H0.5C0.223858 8.5 0 8.27614 0 8C0 7.72386 0.223858 7.5 0.5 7.5H3C3.82843 7.5 4.5 8.17157 4.5 9V11.5C4.5 11.7761 4.27614 12 4 12C3.72386 12 3.5 11.7761 3.5 11.5Z" />
      <path d="M11 1.5C11 1.22386 10.7761 1 10.5 1H1.5C1.22386 1 1 1.22386 1 1.5V10.5C1 10.7761 1.22386 11 1.5 11H10.5C10.7761 11 11 10.7761 11 10.5V1.5ZM12 10.5C12 11.3284 11.3284 12 10.5 12H1.5C0.671573 12 0 11.3284 0 10.5V1.5C0 0.671573 0.671573 0 1.5 0H10.5C11.3284 0 12 0.671573 12 1.5V10.5Z" />
      <path d="M9.14645 2.14645C9.34171 1.95118 9.65822 1.95118 9.85348 2.14645C10.0487 2.34171 10.0487 2.65822 9.85348 2.85348L5.85348 6.85348C5.65822 7.04874 5.34171 7.04874 5.14645 6.85348C4.95118 6.65822 4.95118 6.34171 5.14645 6.14645L9.14645 2.14645Z" />
      <path d="M9 6V3H6C5.72386 3 5.5 2.77614 5.5 2.5C5.5 2.22386 5.72386 2 6 2H9.5C9.77614 2 10 2.22386 10 2.5V6C10 6.27614 9.77614 6.5 9.5 6.5C9.22386 6.5 9 6.27614 9 6Z" />
    </g>
    <defs>
      <clipPath id="a">
        <rect fill="currentColor" height="12" width="12" />
      </clipPath>
    </defs>
  </svg>
));

ExtendBackgroundIcon.displayName = 'ExtendBackgroundIcon';
